import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-stop",
  "use": "icon-icon-stop-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" id=\"icon-icon-stop\"><g fill=\"none\" fill-rule=\"evenodd\"><circle fill=\"#93949D\" cx=\"6\" cy=\"6\" r=\"6\" /><path fill=\"#FFF\" fill-rule=\"nonzero\" d=\"m2.99 6.718 6.004.07.027-1.543-6-.104z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol